// NOTE: revoking synchronously can abort the download; FileSaver.js waits 40s.
const BLOB_URL_REVOKE_DELAY_MS = 40_000;

/**
 * Creates a downloadable link to download a blob and then programmatically
 * clicks it and then removes it.
 */
export const downloadBlob = (content: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(content);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), BLOB_URL_REVOKE_DELAY_MS);
};

/**
 * Hands a URL to the browser's download manager. Cross-origin, `download` is
 * ignored, so the response's Content-Disposition names the file.
 */
export const downloadFromUrl = (url: string) => {
  const a = document.createElement('a');
  a.href = url;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

/**
 * Creates a downloadable link to download a string and then programmatically
 * clicks it and then removes it.
 */
export const downloadStringAsFile = (content: string, fileName: string) => {
  const blob = new Blob([content]);
  downloadBlob(blob, fileName);
};
